<template>
  <div class="glconfig">
    <el-card class="box-card" shadow="never">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="模型配置" name="first">
          <Model></Model>
        </el-tab-pane>
        <el-tab-pane label="面板配置" name="second">
          <Config></Config>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import { getInfo } from '@/utils/auth';
import Config from './components/config'
import Model from './components/model'
import Bind from './components/bind'
export default {
  components: {
    Config,
    Model,
    Bind
  },
  data() {
    return {
      activeName: 'first'
    };
  },
  watch: {},
  methods: {
    handleClick(e) {}
  },
  created() {
  }
};
</script>

<style lang="scss" scoped="scoped">
.glconfig {
}
</style>



// WEBPACK FOOTER //
// src/views/boss/template/glconfig.vue